"use strict";

// =====================================================
// procesar
//
// Archivo:
// src/fronend/procesar/procesar.js
//
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosProcesar = [];


// =====================================================
// ELEMENTOS
// =====================================================

const tablaProcesar =
    document.getElementById("tbodyNomina");

const buscarProcesar =
    document.getElementById("buscarNomina");

const filtroProceso =
    document.getElementById("filtroProceso");

const btnLimpiarBusqueda =
    document.getElementById("btnLimpiarBusqueda");


// =====================================================
// INICIALIZAR
// =====================================================

document.addEventListener("DOMContentLoaded", () => {

    cargarNomina();


    if (buscarProcesar) {

        buscarProcesar.addEventListener(
            "input",
            filtrarNomina
        );

    }


    if (filtroProceso) {

        filtroProceso.addEventListener(
            "change",
            filtrarNomina
        );

    }


    if (btnLimpiarBusqueda) {

        btnLimpiarBusqueda.addEventListener(
            "click",
            limpiarBusqueda
        );

    }


    const btnProcesar =
        document.getElementById(
            "btnProcesarNomina"
        );


    if (btnProcesar) {

        btnProcesar.addEventListener(
            "click",
            procesarNomina
        );

    }

});


// =====================================================
// CARGAR NÓMINA
//
// NO SE CAMBIA LA URL PRINCIPAL.
//
// TAMBIÉN SE CONSULTAN LOS MÓDULOS:
// /dobles/listar
// /decreto/listar
//
// PARA OBTENER LOS VALORES REALES.
// =====================================================

async function cargarNomina() {

    try {

        mostrarCargando();


        // =================================================
        // CARGAR NÓMINA PRINCIPAL
        // =================================================

        const respuestaNomina =
            await fetch(
                "/procesar/listar"
            );


        if (!respuestaNomina.ok) {

            throw new Error(
                "No se pudo obtener la información de la nómina"
            );

        }


        const datosNomina =
            await respuestaNomina.json();


        let nomina =
            Array.isArray(datosNomina)
                ? datosNomina
                : [];


        // =================================================
        // CARGAR HORAS DOBLES
        // =================================================

        let datosDobles = [];


        try {

            const respuestaDobles =
                await fetch(
                    "/dobles/listar"
                );


            if (
                respuestaDobles.ok
            ) {

                const resultadoDobles =
                    await respuestaDobles.json();


                if (
                    Array.isArray(resultadoDobles)
                ) {

                    datosDobles =
                        resultadoDobles;

                }

            }

        } catch (errorDobles) {

            console.warn(
                "No se pudieron cargar los datos de horas dobles:",
                errorDobles
            );

        }


        // =================================================
        // CARGAR BONIFICACIONES
        // =================================================

        let datosBonificaciones = [];


        try {

            const respuestaBonificacion =
                await fetch(
                    "/decreto/listar"
                );


            if (
                respuestaBonificacion.ok
            ) {

                const resultadoBonificacion =
                    await respuestaBonificacion.json();


                if (
                    Array.isArray(resultadoBonificacion)
                ) {

                    datosBonificaciones =
                        resultadoBonificacion;

                }

            }

        } catch (errorBonificacion) {

            console.warn(
                "No se pudieron cargar las bonificaciones:",
                errorBonificacion
            );

        }


        // =================================================
        // INTEGRAR HORAS DOBLES
        // =================================================

        nomina =
            nomina.map(
                registro => {

                    const idEmpleado =
                        Number(
                            registro.IDEMPLEADO
                        );


                    const doble =
                        datosDobles.find(
                            item =>
                                Number(
                                    item.IDEMPLEADO
                                ) === idEmpleado
                        );


                    if (doble) {

                        return {

                            ...registro,

                            // ---------------------------------
                            // VALOR REAL DEL MÓDULO DOBLES
                            // ---------------------------------

                            PAGOHRSDOBLE:
                                obtenerValorDesdeObjeto(
                                    doble,
                                    [
                                        "PAGOHRSDOBLE",
                                        "PAGO HRSDOBLE",
                                        "PAGO POR HORAS DOBLES",
                                        "PAGO POR HORAS DOBLES AL MES",
                                        "TOTALHRSDOBLES"
                                    ]
                                ),

                            HRSDOBLES:
                                obtenerValorDesdeObjeto(
                                    doble,
                                    [
                                        "HRSDOBLES",
                                        "HORASDOBLES"
                                    ]
                                )

                        };

                    }


                    return registro;

                }
            );


        // =================================================
        // INTEGRAR BONIFICACIÓN
        // =================================================

        nomina =
            nomina.map(
                registro => {

                    const idEmpleado =
                        Number(
                            registro.IDEMPLEADO
                        );


                    const bonificacion =
                        datosBonificaciones.find(
                            item =>
                                Number(
                                    item.IDEMPLEADO
                                ) === idEmpleado
                        );


                    if (bonificacion) {

                        return {

                            ...registro,

                            // ---------------------------------
                            // VALOR REAL DEL MÓDULO DECRETO
                            // ---------------------------------

                            PAGOTOTALPORBONIFICACION:
                                obtenerValorDesdeObjeto(
                                    bonificacion,
                                    [
                                        "PAGOTOTALPORBONIFICACION",
                                        "PAGO TOTAL POR BONIFICACION",
                                        "PAGO POR BONIFICACION",
                                        "BONIFICACIONDECRETO",
                                        "VALOR_BONIFICACION_DECRETO"
                                    ]
                                ),

                            BONIFICACIONDECRETO:
                                obtenerValorDesdeObjeto(
                                    bonificacion,
                                    [
                                        "BONIFICACIONDECRETO",
                                        "VALOR_BONIFICACION_DECRETO"
                                    ]
                                )

                        };

                    }


                    return registro;

                }
            );


        // =================================================
        // GUARDAR
        // =================================================

        registrosProcesar =
            nomina;


        // =================================================
        // CONSOLA
        // =================================================

        console.log(
            "DATOS RECIBIDOS DE /procesar/listar:",
            registrosProcesar
        );


        if (
            registrosProcesar.length > 0
        ) {

            console.log(
                "PRIMER REGISTRO DE NÓMINA:",
                registrosProcesar[0]
            );

        }


        renderizarTabla(
            registrosProcesar
        );


        actualizarResumen(
            registrosProcesar
        );


    } catch (error) {

        console.error(
            "ERROR AL CARGAR NÓMINA:",
            error
        );


        if (tablaProcesar) {

            tablaProcesar.innerHTML = `
                <tr>
                    <td colspan="23"
                        class="text-center text-danger py-4">

                        <i class="bi bi-exclamation-triangle-fill me-2"></i>

                        Error al cargar la información de nómina

                    </td>
                </tr>
            `;

        }

    }

}


// =====================================================
// OBTENER VALOR DESDE OBJETO
//
// BUSCA EL PRIMER CAMPO QUE EXISTA.
// =====================================================

function obtenerValorDesdeObjeto(
    objeto,
    campos
) {

    if (!objeto) {

        return 0;

    }


    for (
        const campo of campos
    ) {

        if (
            objeto[campo] !== undefined &&
            objeto[campo] !== null &&
            objeto[campo] !== ""
        ) {

            return objeto[campo];

        }

    }


    return 0;

}


// =====================================================
// MOSTRAR CARGANDO
// =====================================================

function mostrarCargando() {

    if (!tablaProcesar) {

        return;

    }


    tablaProcesar.innerHTML = `
        <tr>
            <td colspan="23"
                class="text-center py-4">

                <div
                    class="spinner-border text-success me-2"
                    role="status">
                </div>

                Cargando información de nómina...

            </td>
        </tr>
    `;

}


// =====================================================
// OBTENER HORAS DOBLES
//
// PRIORIDAD:
//
// 1. PAGOHRSDOBLE
// 2. PAGO HRSDOBLE
// 3. PAGO POR HORAS DOBLES
// 4. PAGO POR HORAS DOBLES AL MES
// 5. TOTALHRSDOBLES
// =====================================================

function obtenerHorasDobles(
    registro
) {

    const valores = [

        registro.PAGOHRSDOBLE,

        registro["PAGO HRSDOBLE"],

        registro["PAGO POR HORAS DOBLES"],

        registro["PAGO POR HORAS DOBLES AL MES"],

        registro.TOTALHRSDOBLES

    ];


    for (
        const dato of valores
    ) {

        if (
            dato !== null &&
            dato !== undefined &&
            dato !== ""
        ) {

            const valorNumerico =
                numero(dato);


            if (
                valorNumerico > 0
            ) {

                return valorNumerico;

            }

        }

    }


    return 0;

}


// =====================================================
// OBTENER BONIFICACIÓN
//
// PRIORIDAD:
//
// 1. PAGOTOTALPORBONIFICACION
// 2. BONIFICACIONDECRETO
// 3. VALOR_BONIFICACION_DECRETO
// 4. PAGO TOTAL POR BONIFICACION
// 5. PAGO POR BONIFICACION
// =====================================================

function obtenerBonificacion(
    registro
) {

    const valores = [

        registro.PAGOTOTALPORBONIFICACION,

        registro.BONIFICACIONDECRETO,

        registro.VALOR_BONIFICACION_DECRETO,

        registro[
            "PAGO TOTAL POR BONIFICACION"
        ],

        registro[
            "PAGO POR BONIFICACION"
        ]

    ];


    for (
        const dato of valores
    ) {

        if (
            dato !== null &&
            dato !== undefined &&
            dato !== ""
        ) {

            const valorNumerico =
                numero(dato);


            if (
                valorNumerico > 0
            ) {

                return valorNumerico;

            }

        }

    }


    return 0;

}


// =====================================================
// OBTENER PRODUCCIÓN
// =====================================================

function obtenerProduccion(
    registro
) {

    const valores = [

        registro[
            "PAGOS POR PRODUCCION BONIFICACION"
        ],

        registro[
            "PAGOTOTALPORPRODUCCIONBONIFICACION"
        ],

        registro[
            "TOTALAPAGARPORPRODUCCIONBONIFICACION"
        ],

        registro.BONIFICACIONPORPRODUCCION

    ];


    for (
        const dato of valores
    ) {

        if (
            dato !== null &&
            dato !== undefined &&
            dato !== ""
        ) {

            const valorNumerico =
                numero(dato);


            if (
                valorNumerico > 0
            ) {

                return valorNumerico;

            }

        }

    }


    return 0;

}


// =====================================================
// OBTENER COMISIONES
// =====================================================

function obtenerComisiones(
    registro
) {

    const valores = [

        registro[
            "PAGO POR COMISIONES EMPLEADOS"
        ],

        registro[
            "TOTALAPAGARPORCOMISIONES"
        ],

        registro[
            "PAGOCOMISIONES"
        ],

        registro.COMISIONES

    ];


    for (
        const dato of valores
    ) {

        if (
            dato !== null &&
            dato !== undefined &&
            dato !== ""
        ) {

            const valorNumerico =
                numero(dato);


            if (
                valorNumerico > 0
            ) {

                return valorNumerico;

            }

        }

    }


    return 0;

}


// =====================================================
// RENDERIZAR TABLA
// =====================================================

function renderizarTabla(
    registros
) {

    if (!tablaProcesar) {

        return;

    }


    tablaProcesar.innerHTML = "";


    if (
        !registros ||
        registros.length === 0
    ) {

        tablaProcesar.innerHTML = `
            <tr>
                <td colspan="23"
                    class="text-center text-muted py-4">

                    <i class="bi bi-inbox fs-3 d-block mb-2"></i>

                    No hay registros de nómina para mostrar.

                </td>
            </tr>
        `;

        return;

    }


    registros.forEach(
        (registro, index) => {

            const fila =
                document.createElement("tr");


            const horasDobles =
                obtenerHorasDobles(
                    registro
                );


            const produccion =
                obtenerProduccion(
                    registro
                );


            const comisiones =
                obtenerComisiones(
                    registro
                );


            const bonificacion =
                obtenerBonificacion(
                    registro
                );


            console.log(
                "========================================"
            );


            console.log(
                "EMPLEADO:",
                registro.IDEMPLEADO
            );


            console.log(
                "HORAS DOBLES:",
                horasDobles
            );


            console.log(
                "BONIFICACIÓN:",
                bonificacion
            );


            console.log(
                "REGISTRO COMPLETO:",
                registro
            );


            fila.innerHTML = `

                <td>
                    ${index + 1}
                </td>

                <td>
                    ${valor(
                        registro.IDEMPLEADO
                    )}
                </td>

                <td>
                    <strong>
                        ${valor(
                            registro.NOMBREEMPLEADO
                        )}
                    </strong>
                </td>

                <td>
                    ${valor(
                        registro.DPI
                    )}
                </td>

                <td>
                    ${valor(
                        registro.NOMBREPUESTO
                    )}
                </td>

                <td>
                    ${valor(
                        registro.NOMBREDEPARTAMENTO
                    )}
                </td>

                <td>
                    ${mostrarProceso(
                        registro.PROCESO
                    )}
                </td>

                <td class="text-end">

                    ${moneda(
                        registro["SUELDO BASE"]
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        registro[
                            "PAGO POR HORAS EXTRAS"
                        ]
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        horasDobles
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        produccion
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        comisiones
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        bonificacion
                    )}

                </td>

                <td class="text-end fw-bold text-success">

                    ${moneda(
                        registro[
                            "TOTAL INGRESADO"
                        ]
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        registro[
                            "PAGO POR ANTICIPADO"
                        ]
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        registro[
                            "DESCUENTO IGSS APLICADO"
                        ]
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        registro[
                            "PAGO POR ISR APLICADO"
                        ]
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        registro[
                            "DESCUENTO APLICADO POR AHORRO DE BANCO TOTAL"
                        ]
                    )}

                </td>

                <td class="text-end">

                    ${moneda(
                        registro[
                            "DESCUENTO POR TIENDA PAGO"
                        ]
                    )}

                </td>

                <td class="text-end fw-bold text-danger">

                    ${moneda(
                        registro[
                            "TOTAL DE EGRESOS"
                        ]
                    )}

                </td>

                <td class="text-end fw-bold">

                    ${moneda(
                        registro.SUELDONUEVO
                    )}

                </td>

                <td>

                    ${mostrarEstado(
                        registro.ESTADO
                    )}

                </td>

                <td class="text-center">

                    <button
                        type="button"
                        class="btn btn-success btn-sm"
                        onclick="abrirModalProcesar(${registro.IDEMPLEADO})"
                        title="Procesar nómina">

                        <i class="bi bi-cash-stack"></i>

                    </button>

                </td>

            `;


            tablaProcesar.appendChild(
                fila
            );

        }
    );

}


// =====================================================
// FILTRAR NÓMINA
// =====================================================

function filtrarNomina() {

    const texto =
        buscarProcesar
            ? buscarProcesar.value
                .trim()
                .toLowerCase()
            : "";


    const proceso =
        filtroProceso
            ? filtroProceso.value
                .trim()
                .toUpperCase()
            : "";


    const filtrados =
        registrosProcesar.filter(
            registro => {

                const empleado =
                    String(
                        registro.NOMBREEMPLEADO ?? ""
                    ).toLowerCase();


                const dpi =
                    String(
                        registro.DPI ?? ""
                    ).toLowerCase();


                const idEmpleado =
                    String(
                        registro.IDEMPLEADO ?? ""
                    ).toLowerCase();


                const puesto =
                    String(
                        registro.NOMBREPUESTO ?? ""
                    ).toLowerCase();


                const procesoRegistro =
                    String(
                        registro.PROCESO ?? ""
                    ).toUpperCase();


                const coincideTexto =
                    empleado.includes(texto) ||
                    dpi.includes(texto) ||
                    idEmpleado.includes(texto) ||
                    puesto.includes(texto);


                const coincideProceso =
                    !proceso ||
                    procesoRegistro === proceso;


                return (
                    coincideTexto &&
                    coincideProceso
                );

            }
        );


    renderizarTabla(
        filtrados
    );


    actualizarResumen(
        filtrados
    );

}


// =====================================================
// LIMPIAR BÚSQUEDA
// =====================================================

function limpiarBusqueda() {

    if (buscarProcesar) {

        buscarProcesar.value = "";

    }


    if (filtroProceso) {

        filtroProceso.value = "";

    }


    renderizarTabla(
        registrosProcesar
    );


    actualizarResumen(
        registrosProcesar
    );

}


// =====================================================
// ABRIR MODAL
// =====================================================

async function abrirModalProcesar(
    idEmpleado
) {

    try {

        const respuesta =
            await fetch(
                `/procesar/buscar/${idEmpleado}`
            );


        if (!respuesta.ok) {

            throw new Error(
                "No se encontró la información del empleado"
            );

        }


        const datos =
            await respuesta.json();


        if (
            !Array.isArray(datos) ||
            datos.length === 0
        ) {

            alert(
                "No se encontró información de nómina."
            );

            return;

        }


        let registro =
            datos[0];


        // =================================================
        // TOMAR LOS DATOS YA INTEGRADOS
        // =================================================

        const registroPrincipal =
            registrosProcesar.find(
                item =>
                    Number(
                        item.IDEMPLEADO
                    ) === Number(
                        idEmpleado
                    )
            );


        if (registroPrincipal) {

            registro = {

                ...registro,

                ...registroPrincipal

            };

        }


        colocarValor(
            "idEmpleadoNomina",
            registro.IDEMPLEADO
        );


        colocarValor(
            "nombreEmpleadoNomina",
            registro.NOMBREEMPLEADO
        );


        colocarValor(
            "dpiEmpleadoNomina",
            registro.DPI
        );


        colocarValor(
            "puestoEmpleadoNomina",
            registro.NOMBREPUESTO
        );


        colocarValor(
            "departamentoEmpleadoNomina",
            registro.NOMBREDEPARTAMENTO
        );


        colocarValor(
            "procesoEmpleadoNomina",
            registro.PROCESO
        );


        colocarValor(
            "modalSalarioBase",
            moneda(
                registro["SUELDO BASE"]
            )
        );


        colocarValor(
            "modalHorasExtras",
            moneda(
                registro[
                    "PAGO POR HORAS EXTRAS"
                ]
            )
        );


        const horasDobles =
            obtenerHorasDobles(
                registro
            );


        colocarValor(
            "modalHorasDobles",
            moneda(
                horasDobles
            )
        );


        const produccion =
            obtenerProduccion(
                registro
            );


        colocarValor(
            "modalProduccion",
            moneda(
                produccion
            )
        );


        const comisiones =
            obtenerComisiones(
                registro
            );


        colocarValor(
            "modalComisiones",
            moneda(
                comisiones
            )
        );


        const bonificacion =
            obtenerBonificacion(
                registro
            );


        colocarValor(
            "modalBonificacion",
            moneda(
                bonificacion
            )
        );


        colocarValor(
            "modalAnticipo",
            moneda(
                registro[
                    "PAGO POR ANTICIPADO"
                ]
            )
        );


        colocarValor(
            "modalIGSS",
            moneda(
                registro[
                    "DESCUENTO IGSS APLICADO"
                ]
            )
        );


        colocarValor(
            "modalISR",
            moneda(
                registro[
                    "PAGO POR ISR APLICADO"
                ]
            )
        );


        colocarValor(
            "modalAsociacion",
            moneda(
                registro[
                    "DESCUENTO APLICADO POR AHORRO DE BANCO TOTAL"
                ]
            )
        );


        colocarValor(
            "modalTienda",
            moneda(
                registro[
                    "DESCUENTO POR TIENDA PAGO"
                ]
            )
        );


        calcularTotalesModal(
            registro
        );


        const procesoNomina =
            document.getElementById(
                "procesoNomina"
            );


        if (procesoNomina) {

            procesoNomina.value =
                registro.PROCESO ??
                "PROCESAR";

        }


        const estadoNomina =
            document.getElementById(
                "estadoNomina"
            );


        if (estadoNomina) {

            estadoNomina.value =
                registro.ESTADO ??
                "A";

        }


        const btnProcesar =
            document.getElementById(
                "btnProcesarNomina"
            );


        if (btnProcesar) {

            btnProcesar.dataset.idEmpleado =
                registro.IDEMPLEADO;

        }


        const elementoModal =
            document.getElementById(
                "modalProcesarNomina"
            );


        if (elementoModal) {

            const modal =
                bootstrap.Modal
                    .getOrCreateInstance(
                        elementoModal
                    );


            modal.show();

        }

    } catch (error) {

        console.error(
            "ERROR AL ABRIR NÓMINA:",
            error
        );


        alert(
            "No se pudo cargar la información de la nómina."
        );

    }

}


// =====================================================
// PROCESAR NÓMINA
// =====================================================

async function procesarNomina() {

    try {

        const btnProcesar =
            document.getElementById(
                "btnProcesarNomina"
            );


        if (!btnProcesar) {

            alert(
                "No se encontró el botón para procesar la nómina."
            );

            return;

        }


        const idEmpleado =
            Number(
                btnProcesar.dataset.idEmpleado
            );


        if (
            !Number.isFinite(idEmpleado) ||
            idEmpleado <= 0
        ) {

            alert(
                "No se encontró el ID del empleado."
            );

            return;

        }


        const registro =
            registrosProcesar.find(
                item =>
                    Number(
                        item.IDEMPLEADO
                    ) === idEmpleado
            );


        if (!registro) {

            alert(
                "No se encontró el registro de nómina del empleado."
            );

            return;

        }


        const totales =
            calcularTotalesModal(
                registro
            );


        const salarioBase =
            numero(
                registro[
                    "SUELDO BASE"
                ]
            );


        const procesoNomina =
            document.getElementById(
                "procesoNomina"
            );


        const proceso =
            procesoNomina
                ? procesoNomina.value
                : "PROCESADO";


        const estadoNomina =
            document.getElementById(
                "estadoNomina"
            );


        const estado =
            estadoNomina
                ? estadoNomina.value
                : "A";


        const confirmar =
            confirm(
                "¿Desea procesar y guardar la nómina de este empleado?"
            );


        if (!confirmar) {

            return;

        }


        btnProcesar.disabled = true;


        btnProcesar.innerHTML = `
            <span
                class="spinner-border spinner-border-sm me-1"
                role="status">
            </span>

            Procesando...
        `;


        const respuesta =
            await fetch(
                `/procesar/actualizar/${idEmpleado}`,
                {
                    method: "PUT",

                    headers: {
                        "Content-Type":
                            "application/json"
                    },

                    body: JSON.stringify({

                        salarioBase:
                            salarioBase,

                        totalIngresado:
                            totales.totalIngresos,

                        totalEgresos:
                            totales.totalEgresos,

                        sueldoNuevo:
                            totales.sueldoNeto,

                        proceso:
                            proceso,

                        estado:
                            estado

                    })

                }
            );


        const datosRespuesta =
            await respuesta.json();


        if (!respuesta.ok) {

            throw new Error(
                datosRespuesta.message ||
                "No se pudo actualizar la nómina."
            );

        }


        alert(
            "La nómina fue procesada y guardada correctamente."
        );


        const elementoModal =
            document.getElementById(
                "modalProcesarNomina"
            );


        if (elementoModal) {

            const modal =
                bootstrap.Modal
                    .getOrCreateInstance(
                        elementoModal
                    );


            modal.hide();

        }


        await cargarNomina();


    } catch (error) {

        console.error(
            "ERROR AL PROCESAR NÓMINA:",
            error
        );


        alert(
            error.message ||
            "Ocurrió un error al procesar la nómina."
        );


    } finally {

        const btnProcesar =
            document.getElementById(
                "btnProcesarNomina"
            );


        if (btnProcesar) {

            btnProcesar.disabled = false;

            btnProcesar.innerHTML = `
                <i class="bi bi-check-circle me-1"></i>
                Procesar nómina
            `;

        }

    }

}


// =====================================================
// CALCULAR TOTALES DEL MODAL
// =====================================================

function calcularTotalesModal(
    registro
) {

    const sueldoBase =
        numero(
            registro[
                "SUELDO BASE"
            ]
        );


    const horasExtras =
        numero(
            registro[
                "PAGO POR HORAS EXTRAS"
            ]
        );


    const horasDobles =
        obtenerHorasDobles(
            registro
        );


    const produccion =
        obtenerProduccion(
            registro
        );


    const comisiones =
        obtenerComisiones(
            registro
        );


    const bonificacion =
        obtenerBonificacion(
            registro
        );


    const totalIngresos =
        sueldoBase +
        horasExtras +
        horasDobles +
        produccion +
        comisiones +
        bonificacion;


    const anticipo =
        numero(
            registro[
                "PAGO POR ANTICIPADO"
            ]
        );


    const igss =
        numero(
            registro[
                "DESCUENTO IGSS APLICADO"
            ]
        );


    const isr =
        numero(
            registro[
                "PAGO POR ISR APLICADO"
            ]
        );


    const asociacion =
        numero(
            registro[
                "DESCUENTO APLICADO POR AHORRO DE BANCO TOTAL"
            ]
        );


    const tienda =
        numero(
            registro[
                "DESCUENTO POR TIENDA PAGO"
            ]
        );


    const totalEgresos =
        anticipo +
        igss +
        isr +
        asociacion +
        tienda;


    const sueldoNeto =
        totalIngresos -
        totalEgresos;


    colocarValor(
        "modalTotalIngresos",
        moneda(
            totalIngresos
        )
    );


    colocarValor(
        "modalTotalEgresos",
        moneda(
            totalEgresos
        )
    );


    colocarValor(
        "resumenTotalIngresos",
        moneda(
            totalIngresos
        )
    );


    colocarValor(
        "resumenTotalEgresos",
        moneda(
            totalEgresos
        )
    );


    colocarValor(
        "resumenSueldoNeto",
        moneda(
            sueldoNeto
        )
    );


    return {

        totalIngresos:
            totalIngresos,

        totalEgresos:
            totalEgresos,

        sueldoNeto:
            sueldoNeto

    };

}


// =====================================================
// ACTUALIZAR RESUMEN
// =====================================================

function actualizarResumen(
    registros
) {

    let totalEmpleados = 0;

    let totalIngresos = 0;

    let totalEgresos = 0;

    let totalNeto = 0;


    registros.forEach(
        registro => {

            totalEmpleados++;


            totalIngresos += numero(
                registro[
                    "TOTAL INGRESADO"
                ]
            );


            totalEgresos += numero(
                registro[
                    "TOTAL DE EGRESOS"
                ]
            );


            totalNeto += numero(
                registro.SUELDONUEVO
            );

        }
    );


    colocarValor(
        "totalEmpleados",
        totalEmpleados
    );


    colocarValor(
        "totalIngresos",
        moneda(
            totalIngresos
        )
    );


    colocarValor(
        "totalEgresos",
        moneda(
            totalEgresos
        )
    );


    colocarValor(
        "totalNeto",
        moneda(
            totalNeto
        )
    );

}


// =====================================================
// FORMATEAR MONEDA
// =====================================================

function moneda(
    valor
) {

    const numeroValor =
        numero(valor);


    return new Intl.NumberFormat(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    ).format(
        numeroValor
    );

}


// =====================================================
// CONVERTIR A NÚMERO
// =====================================================

function numero(
    valor
) {

    if (
        valor === null ||
        valor === undefined ||
        valor === ""
    ) {

        return 0;

    }


    if (
        typeof valor === "string"
    ) {

        valor =
            valor
                .replace(/,/g, "")
                .trim();

    }


    const resultado =
        Number(valor);


    return Number.isFinite(
        resultado
    )
        ? resultado
        : 0;

}


// =====================================================
// COLOCAR VALOR
// =====================================================

function colocarValor(
    id,
    valor
) {

    const elemento =
        document.getElementById(id);


    if (!elemento) {

        return;

    }


    if (
        elemento.tagName === "INPUT" ||
        elemento.tagName === "SELECT" ||
        elemento.tagName === "TEXTAREA"
    ) {

        elemento.value =
            valor ?? "";

        return;

    }


    elemento.textContent =
        valor ?? "";

}


// =====================================================
// VALOR SEGURO
// =====================================================

function valor(
    dato
) {

    if (
        dato === null ||
        dato === undefined ||
        dato === ""
    ) {

        return "-";

    }


    return String(dato);

}


// =====================================================
// MOSTRAR PROCESO
// =====================================================

function mostrarProceso(
    proceso
) {

    const valorProceso =
        String(
            proceso ?? ""
        ).toUpperCase();


    if (
        valorProceso === "PAGADO"
    ) {

        return `
            <span class="badge bg-success">
                PAGADO
            </span>
        `;

    }


    if (
        valorProceso === "PROCESAR"
    ) {

        return `
            <span class="badge bg-warning text-dark">
                PROCESAR
            </span>
        `;

    }


    if (
        valorProceso === ""
    ) {

        return `
            <span class="badge bg-secondary">
                -
            </span>
        `;

    }


    return `
        <span class="badge bg-primary">
            ${valorProceso}
        </span>
    `;

}


// =====================================================
// MOSTRAR ESTADO
// =====================================================

function mostrarEstado(
    estado
) {

    const valorEstado =
        String(
            estado ?? ""
        ).toUpperCase();


    if (
        valorEstado === "A"
    ) {

        return `
            <span class="badge bg-success">
                ACTIVO
            </span>
        `;

    }


    if (
        valorEstado === "P"
    ) {

        return `
            <span class="badge bg-warning text-dark">
                PENDIENTE
            </span>
        `;

    }


    if (
        valorEstado === "I"
    ) {

        return `
            <span class="badge bg-danger">
                INACTIVO
            </span>
        `;

    }


    return `
        <span class="badge bg-secondary">
            ${valorEstado || "-"}
        </span>
    `;

}


// =====================================================
// EXPONER FUNCIÓN PARA EL HTML
// =====================================================

window.abrirModalProcesar =
    abrirModalProcesar;